<div class="card"
  style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
  <div class="card-header card-chart card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h5 class="card-title text-center"><strong>Alta Usuario</strong></h5>
      </div>
      <div class="col-sm-12 col-md-1">
        <button mat-icon-button (click)="onClicCerrarModal()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div mat-dialog-content class="pb-2">
          <mat-accordion class="example-headers-align">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <i class="material-icons mr-2"> work_outline</i> Datos de Usuario
              </mat-expansion-panel-header>
              <div>
                <form [formGroup]="formUser">
                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field>
                        <input matInput aria-label="Nombre" placeholder="Nombre" type="text" id="nombreUsuario" name="nombreUsuario"
                          formControlName="controlNombre" maxlength="30" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field>
                        <input matInput aria-label="Apellido paterno:" placeholder="Apellido paterno:" type="text" id="aPaterno" name="aPaterno"
                          oninput="this.value = this.value.trim()" formControlName="controlAPaterno" maxlength="25" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field>
                        <input matInput aria-label="Apellido materno:" placeholder="Apellido materno:" type="text" id="aMaterno" name="aMaterno"
                          oninput="this.value = this.value.trim()" formControlName="controlAMaterno" maxlength="25" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field>
                        <input matInput aria-label="Email:" placeholder="Email:" type="email" id="email" name="email" maxlength="60"
                          oninput="this.value = this.value.trim()" formControlName="controlEmail" />
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <i class="material-icons mr-2"> perm_identity </i> Datos del Usuario
              </mat-expansion-panel-header>
              <form [formGroup]="formGroupUser">
                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field>
                      <input matInput aria-label="Usuario:" notCopyPaste placeholder="Usuario:" type="text" id="usuario" name="usuario"
                        formControlName="controlUsuario" maxlength="20" oninput="this.value = this.value.trim()"
                         />
                    </mat-form-field>
                    <!--   <mat-error>Usuario menor a 5 caracteres</mat-error> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field>
                      <input matInput aria-label="Contraseña:" notCopyPaste placeholder="Contraseña:" type="password" id="contra" name="contra"
                        formControlName="controlPass" maxlength="20" oninput="this.value = this.value.trim()" />
                    </mat-form-field>
                    <!-- <mat-error>Contraseña menor a 6 caracteres</mat-error> -->
                  </div>
                  <div class="col-md-12">
                    <mat-form-field>
                      <input matInput aria-label="Confirmar contraseña:" notCopyPaste placeholder="Confirmar contraseña:" type="password" id="confirmarContra"
                        oninput="this.value = this.value.trim()" maxlength="20" name="contra"
                        formControlName="controlRePass" />
                    </mat-form-field>
                    <!-- <mat-error>Contraseñas deben de coincidir</mat-error> -->
                  </div>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div mat-dialog-actions class="justify-content-end pb-4">
          <button mat-raised-button class="btn btn-info btn-github" (click)="onClicCerrarModal()">
            <i class="fa fa-times-circle-o"></i> Cancelar
          </button>
          <button mat-button (click)="ClickGuardar()" class="btn btn-success">
            Guardar <i class="material-icons"> save </i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>